'use es6';

import { Map as ImmutableMap, Record } from 'immutable';
import { AudienceSources, Networks } from '../../lib/Constants';
export default class AudienceCountsRecord extends Record({
  networkAudienceSourceCounts: ImmutableMap()
}) {
  // Backwards compatibility
  get contactListAudiences() {
    return this.networkAudienceSourceCounts.reduce((contactListCount, bySource) => contactListCount + bySource.get(AudienceSources.HUBSPOT_CONTACT_LIST, 0) + bySource.get(AudienceSources.HUBSPOT_CONTACT_SEARCH, 0), 0);
  }

  get companyListAudiences() {
    return this.networkAudienceSourceCounts.getIn([Networks.LINKEDIN, AudienceSources.HUBSPOT_COMPANY_LIST], 0);
  } // Backwards compatibility


  get facebookPixelAudiences() {
    return this.networkAudienceSourceCounts.getIn([Networks.FACEBOOK, AudienceSources.NETWORK_PIXEL], 0);
  }

  get facebookAudiences() {
    return this.networkAudienceSourceCounts.get(Networks.FACEBOOK, ImmutableMap()).reduce((facebookCount, count) => facebookCount + count, 0);
  }

  get lookalikeAudiences() {
    return this.networkAudienceSourceCounts.reduce((lookalikeCount, bySource) => lookalikeCount + bySource.get(AudienceSources.SEED_AUDIENCE, 0), 0);
  }

  get websiteAudiences() {
    return this.networkAudienceSourceCounts.reduce((websiteCount, bySource) => websiteCount + bySource.get(AudienceSources.NETWORK_PIXEL, 0), 0);
  }

}